import { Pipe, PipeTransform } from '@angular/core';
import moment, { Moment } from "moment";

@Pipe({
    name: 'dateify',
    standalone: false
})
export class DateifyPipe implements PipeTransform {

  transform(date: string|Date|Moment|null, ...args: unknown[]): Date|null {
    if(date instanceof Date){
      return date;
    }
    else if(moment.isMoment(date)){
      // what the Moment-backed pickers return since #1175
      return date.toDate();
    }
    else if(date){
      const d = moment(date.substr(0, 10)); // removes TZ information
      return d.toDate();
    }
    return null;
  }

}
